export const powerBI = {
  /**
   * @method GET
   * @param attributes options to show view infos ex.: ["id", "title", "description"]
   * @return {Array}
   */
  list: '/v2/api/aawz-bi/dashboard?attributes=["id", "title", "description"]',
  /**
   * @method GET
   * @param {String} dashboard id dashboard
   * @return {Object}
   */
  getUpdate: (dashboard) => `/v2/api/aawz-bi/metadata?dashboard=${dashboard}`,
}

export const permissionsBI = {
  /**
   * @method GET
   * @return {Array}
   *
   * @method POST
   * @param {Object} data ex.: { "id_profissional": 2395, "id_dashboard": "c1430987-6b85-4c53-af44-aa39b45a212e"}
   */
  list: `/v2/api/aawz-bi/permissions`,
  /**
   * @method PUT
   * @method DELETE
   * @param {String} id uuid of the permission to delete
   */
  editDelete: (id) => `/v2/api/aawz-bi/permissions/${id}`,
  /**
   * @method POST
   * @method GET
   * @param {Array} data ex: teste: [{ ,
        "id_profissional": 2395,
        "id_dashboard": "c1430987-6b85-4c53-af44-aa39b45a212e"}, {}]
   */

  lotePermissions: '/v2/api/aawz-bi/import-export/permissions',
}

export const embed = {
  /**
   * @method GET
   * @param {Numbers} id_profissional
   */
  report: (id_profissional) =>
    id_profissional
      ? `/v2/api/aawz-bi/embedded/report?id_profissional=${id_profissional}`
      : '/v2/api/aawz-bi/embedded/report',
}

export const cacheBI = {
  /**
   * @method GET get date update
   */
  get: '/v2/api/aawz-bi/cache/metadata',
  /**
   * @method POST update cache
   */
  update: '/v2/api/aawz-bi/cache/update',
}
